import "./LanguageCurrencyMenu.css";

const Row = ({ checked, onClick, children }) => (
  <button type="button" className="lcm-row" onClick={onClick} role="radio" aria-checked={checked}>
    <span className={"lcm-radio"+(checked?" is-on":"")} /> {children}
  </button>
);

export default function LanguageCurrencyMenu({ languageOptions=[], currencyOptions=[], selectedLanguage, selectedCurrency, onSelectLanguage, onSelectCurrency }) {
  return (
    <div className="gnb-menu-card lcm-card" style={{width:200}}>
      <p className="lcm-heading">Change Language</p>
      <div className="lcm-divider" />
      {languageOptions.map(o=>(
        <Row key={o.value} checked={o.value===selectedLanguage} onClick={()=>onSelectLanguage(o.value)}>
          {o.name} - {String(o.value).toUpperCase()}
        </Row>
      ))}
      <p className="lcm-heading">Change Currency</p>
      <div className="lcm-divider" />
      {currencyOptions.map(o=>(
        <Row key={o.value} checked={o.value===selectedCurrency} onClick={()=>onSelectCurrency(o.value)}>{o.shortName||o.name}</Row>
      ))}
    </div>
  );
}
